import { useCallback, useState } from 'react';
import BZAPIService from '../../../services/BZAPIService';

/**
 * Applies a completed inventory scan to an existing project.
 *
 * Returns null on failure rather than throwing, so the caller keeps showing
 * the snapshot the user already had — a failed refresh must never blank out
 * good data.
 */
export default function useProjectRefresh() {
  const [refreshing, setRefreshing] = useState(false);
  const [refreshError, setRefreshError] = useState(null);

  const clearRefreshError = useCallback(() => setRefreshError(null), []);

  const applyRefresh = useCallback(async (projectId, fetchJobId) => {
    setRefreshing(true);
    setRefreshError(null);
    try {
      const updated = await BZAPIService.bsaInvRefreshSnapshot(projectId, fetchJobId);
      setRefreshing(false);
      return updated;
    } catch (e) {
      setRefreshing(false);
      setRefreshError('Could not refresh the inventory. Please try again.');
      return null;
    }
  }, []);

  return { refreshing, refreshError, applyRefresh, clearRefreshError };
}
